<template>
  <div class="page--pre-origination--workbench">
    <v-container grid-list-xl fluid>
      <v-layout row>
        <v-flex lg9 v-if=isShowSearch>
          <arb-loan-list @setPagenation="getPagination" :loanData="complex" :title="complex.title"></arb-loan-list>
        </v-flex>
        <v-flex lg3 class="text-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-if="isEnable" text icon color="amber darken-1" class="action-generate size-150x150 m-v-20" slot="activator"
                     :loading="loading4"
                     @click.native="loader = 'loading4'"
                     @click="getHasLockedLoan"
                     :disabled="loading4"
                     v-bind="attrs"
                     v-on="on"
              >
                <v-icon class="f-s-50">repeat</v-icon>
                <span slot="loader" class="custom-loader">
                  <v-icon light class="f-s-50">cached</v-icon>
                </span>
              </v-btn>
<!--              generateApplication-->
              <v-btn v-else text icon color="amber darken-1" class="prohibit-generate size-150x150 m-v-20" slot="activator"
                     :loading="loading4"
                     @click.native="loader = 'loading4'"
                     disabled
                     v-bind="attrs"
                     v-on="on"
              >
                <v-icon class="f-s-50" color="grey">repeat</v-icon>
                <span slot="loader" class="custom-loader">
                  <v-icon light class="f-s-50">cached</v-icon>
                </span>
              </v-btn>
            </template>
            <span>Generate Application</span>
          </v-tooltip>
          <!--<box-chart class="mt-4"
                     card-color="pink lighten-1"
                     title="Visit Trend"
                     height="150px"
                     sub-title="10%"
                     icon="trending_up"
                     :data="siteTrafficData"
                     :chart-color="[color.pink.darken2]"
                     type="bar"
                     v-if="isShowElement(privileges, dataType.PrivilegeCode.VISIT_TREND_CHART, dataType.PrivilegeType.READABLE)"
          >
          </box-chart>
          <box-chart class="mt-4"
                     card-color="teal lighten-1"
                     title="Approved Number"
                     height="150px"
                     sub-title="10%"
                     icon="trending_up"
                     :data="siteTrafficData"
                     :chart-color="[color.teal.darken2]"
                     type="bar"
                     v-if="isShowElement(privileges, dataType.PrivilegeCode.APPROVED_NUMBER_CHART, dataType.PrivilegeType.READABLE)"
          >
          </box-chart>
          <box-chart class="mt-4"
                     card-color="teal lighten-1"
                     title="Approved Amount"
                     height="150px"
                     sub-title="10%"
                     icon="trending_up"
                     :data="siteTrafficData"
                     :chart-color="[color.teal.darken2, 'rgba(255,255,255,0.3)']"
                     gradient
                     type="area"
                     v-if="isShowElement(privileges, dataType.PrivilegeCode.APPROVED_AMOUNT_CHART, dataType.PrivilegeType.READABLE)"
          >
          </box-chart>
          <arb-basic-card title="Contribution" content-bg="white" class="mt-4"
                    v-if="isShowElement(privileges, dataType.PrivilegeCode.CONTRIBUTION_CHART, dataType.PrivilegeType.READABLE)"
          >
            <div slot="widget-content">
              <e-chart
                :path-option="[
                  ['dataset.source', locationData],
                  ['legend.bottom', '0'],
                  ['color', [color.lightBlue.base, color.indigo.base, color.pink.base, color.green.base, color.cyan.base, color.teal.base]],
                  ['xAxis.show', false],
                  ['yAxis.show', false],
                  ['series[0].type', 'pie'],
                  ['series[0].avoidLabelOverlap', true],
                  ['series[0].radius', ['50%', '70%']],
                ]"
                height="300px"
                width="100%"
              >
              </e-chart>
            </div>
          </arb-basic-card>-->
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="41%" v-model="basic.dialog">
      <v-card>
        <v-card-title>
          <span class="headline">GENERATE</span>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="basic.loanStatus" row>
            <v-radio
              v-for="(item, index) in basic.restrict"
              :label="item.text"
              :value="item.value"
              :key="index"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="basic.dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="generateApplication">Go for it</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="40%" v-model="locked.isShowLocked">
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>We found an existing loan locked: {{locked.loanNumber}}？</v-toolbar-title>
            <v-btn
              icon
              dark
              @click="dialog.value = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
              <v-radio-group v-model="locked.loanStatus" column>
                <v-radio
                  label="Continue with the previous loan"
                  value="Locked-Loan"
                ></v-radio>
                <v-radio
                  label="Unlock and generate a new loan"
                  value="New-Loan"
                ></v-radio>
              </v-radio-group>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="getLoan">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import API from '@/api'
import {
  StackData,
  SinData,
  monthVisitData,
  campaignData,
  locationData
} from '@/api/chart'
import { getPost } from '@/api/post'
import Material from 'vuetify/es5/util/colors'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header.js'
import { LoanOperationApi, OriginationApi } from '@/api/pandaria'
import { Authentication, Tool, DataType, Crypto, Popup, Cache } from '@/util/index'
import Swal from 'sweetalert2'
const tool = new Tool()
const popup = new Popup()
const cache = new Cache()
export default {
  components: {
  },
  data () {
    return {
      isEnable: true,
      column: null,
      row: null,
      locked: {
        loanStatus: '',
        isShowLocked: false,
        loanNumber: ''
      },
      loanId: '',
      assist: {
        tool: tool
      },
      basic: {
        dialog: false,
        loanStatus: '',
        restrict: []
      },
      dataset: {
        sinData: SinData,
        monthVisit: monthVisitData,
        campaign: campaignData,
        location: locationData,
        stackData: StackData
      },
      isShowSearch: false,
      color: Material,
      text: 'center',
      icon: 'justify',
      toggle_none: null,
      toggle_one: 0,
      toggle_exclusive: 2,
      toggle_multiple: [0, 1, 2],
      loader: null,
      loading: false,
      loading2: false,
      loading3: false,
      loading4: false,
      complex: {
        headers: LIST_TABLE_HEADER.preOriginationWorkbenchTable,
        items: [],
        title: 'workbench'
      },
      pagination: {},
      dataType: DataType,
      privileges: [],
      timer: null
    }
  },
  created () {
    const nowTime = new Date().getTime()
    const current = JSON.parse(localStorage.getItem('generateCurrentTime'))
    if (tool.isNotEmpty(current)) {
      this.isEnable = current.isEnable
      const timeDifference = (nowTime / 1000) - (current.currentTime / 1000)
      if (timeDifference >= 20) {
        this.isEnable = true
      } else {
        this.timer = setTimeout(() => {
          this.isEnable = true
        }, (20 - timeDifference) * 1000)
      }
    }
  },
  computed: {
    posts () {
      return getPost()
    },
    siteTrafficData () {
      return API.getMonthVisit
    },
    locationData () {
      return API.getLocation
    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => {
        this[l] = false
      }, 3000)
      this.loader = null
    },
    pagination (newValue) {
      // alert(JSON.stringify(newValue));
    },
    'store.getters.getAuthorization': {
      handler: function () {
        const authorization = this.store.getters.getAuthorization
        if (tool.isNotEmpty(authorization)) {
          this.privileges = authorization.privileges
          this.isShowSearch = this.isShowElement(this.privileges, this.dataType.PrivilegeCode.WORKBENCH_SEARCH, this.dataType.PrivilegeType.READABLE)
          this.$forceUpdate()
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  destroyed () {
    this.$eventBus.$off('updateAccount')
  },
  mounted () {
  },
  methods: {
    async getHasLockedLoan () {
      const $this = this
      await LoanOperationApi.hasLockedLoan(function (result) {
        if (result.hasLockedLoan) {
          $this.showHasLockedDialog()
          $this.loanId = result.loanId
          $this.locked.loanNumber = result.loanNo
        } else {
          $this.generateApplication()
        }
      }, function (err) {
        popup.popupForWarning(err.message)
      })
    },
    showHasLockedDialog () {
      this.locked.isShowLocked = true
    },
    getLoan () {
      const $this = this
      const loanId = $this.loanId
      if (!tool.isEmpty($this.locked.loanStatus)) {
        if ($this.locked.loanStatus === 'Locked-Loan') {
          $this.isEnable = false
          const currentTime = new Date().getTime()
          const current = {
            currentTime: currentTime,
            isEnable: $this.isEnable
          }
          $this.$eventBus.$emit('side-icon-click')
          // TODO correct uri application -> loan
          cache.setSessionLoanId(Crypto.encrypt(loanId))
          localStorage.setItem('generateCurrentTime', JSON.stringify(current))
          $this.$router.push('/pre-origination/application')
        } else {
          this.generateApplication()
        }
      } else {
        popup.popupForWarning('You need to select the type of loan')
        return
      }
      $this.locked.isShowLocked = false
    },
    handleClick: (e) => {
      console.log(e)
    },
    getPagination (payload) {
      this.pagination = payload
    },
    showDialog () {
      this.basic.dialog = true
    },
    async generateApplication () {
      const $this = this
      this.basic.restrict = []
      const authorization = this.store.getters.getAuthorization
      // const account = this.store.getters.getAccount
      const roleCode = $this.store.getters.getRoleCode
      const restrictValueArray = []
      let idGenerate = [
        DataType.LoanStatus.AGENT_REVIEW.value,
        DataType.LoanStatus.UNDERWRITER_REVIEW.value,
        DataType.LoanStatus.CORRECTOR_REVIEW.value,
        DataType.LoanStatus.TRIBE_REVIEW.value
      ]
      if (tool.isEmpty(roleCode)) {
        popup.popupForWarning('Please wait a minute')
        return
      } else if (roleCode === DataType.RoleEnum.RETENTION_AGENT.code) {
        idGenerate = [
          DataType.LoanStatus.NEGATIVE_WITHDRAWN.value,
          DataType.LoanStatus.POSITIVE_WITHDRAWN.value
        ]
      } else if (roleCode === DataType.RoleEnum.RETENTION_CUSTOMER_POC.code) {
        idGenerate.push(DataType.LoanStatus.NEGATIVE_WITHDRAWN.value, DataType.LoanStatus.POSITIVE_WITHDRAWN.value)
      } else if (roleCode === DataType.RoleEnum.ORIGINATION_AGENT.code) {
        idGenerate = [DataType.LoanStatus.AGENT_REVIEW.value]
      } else if (roleCode === DataType.RoleEnum.CORRECTION_AGENT.code) {
        idGenerate = [DataType.LoanStatus.CORRECTOR_REVIEW.value]
      }

      const loanStatusArray = []
      for (const item of authorization.restricts) {
        if (!loanStatusArray.includes(item.loanStatus) && idGenerate.includes(item.loanStatus)) {
          restrictValueArray.push(item)
          loanStatusArray.push(item.loanStatus)
        }
      }

      for (const restrictValue of restrictValueArray) {
        const restrict = {
          value: restrictValue.loanStatus,
          text: tool.getLoanStatus(restrictValue.loanStatus)
        }

        $this.basic.restrict.push(restrict)
      }

      const restrictLength = this.basic.restrict.length
      let loanStatus
      const category = 1 // 1-New, 2-Returning
      // const portfolioList = account.portfolioIdList
      const portfolioList = this.$store.getters.getRuntimePortfolio
      if (restrictLength >= 1) {
        if (restrictLength === 1) {
          loanStatus = this.basic.restrict[0].value
        } else {
          if (this.basic.dialog === false) {
            this.showDialog()
            return
          } else {
            if (this.locked.loanStatus === 'New-Loan') {
              await LoanOperationApi.unlockLoan({ loanId: this.loanId, unlockReason: DataType.UnlockLoanReasonEnum.MANUAL_UNLOCK.value })
            }
            loanStatus = this.basic.loanStatus
          }
        }

        if (tool.isEmpty(loanStatus)) {
          popup.popupForWarning('You need to select the type of loan')
          return
        }

        const $this = this
        $this.$store.commit('setLockReason', DataType.LockLoanReasonEnum.GENERATE_LOAN.value)
        await LoanOperationApi.generate(loanStatus, portfolioList, category, function (result) {
          const loanId = tool.isNotEmpty(result) ? result : ''
          if (tool.isNotEmpty(loanId)) {
            $this.isEnable = false
            const currentTime = new Date().getTime()
            const current = {
              currentTime: currentTime,
              isEnable: $this.isEnable
            }
            $this.$eventBus.$emit('side-icon-click')
            // TODO correct uri application -> loan
            cache.setSessionLoanId(Crypto.encrypt(loanId))
            localStorage.setItem('generateCurrentTime', JSON.stringify(current))
            $this.$router.push('/pre-origination/application')
          } else {
            popup.popupForWarning('There are not enough loans')
          }
        }, function (err) {
          if (err.code === DataType.AjaxResultCodeEnum.GENERATE_IN_SHORT_TIME.value) {
            Swal.fire({
              html:
                '<i class="fad fa-mug-hot text-light-blue alert-icon"></i><p class="alert-text m-t-20">You are generating leads too aggressively.</p><p class="alert-text">Please re-retry in a few seconds.</p>',
              focusConfirm: false
            })
          } else {
            popup.popupForWarning(err.message)
          }
        })
      } else {
        popup.popupForWarning('Failure: Failed to generate loan.')
      }
    },
    getTrackerList () {
      const $this = this
      const account = this.store.getters.getAccount
      if (tool.isEmpty(account)) {
        return
      }

      const request = {
        feature: 'TRACKER_LIST',
        condition: {
          trackedId: account.id
        }
      }
      OriginationApi.listSectionFeature(request, function (result) {
        if (tool.isNotEmpty(result)) {
          for (const item of result) {
            item.fullName = tool.getFullName(item)
            item.action = 'trackerList'
            item.version = DataType.LoanVersion.V3_LOAN
            item.action = 'trackerList'
          }
          $this.complex.items = result
        }
      })
    },
    isShowElement (privileges, code, value) {
      return Authentication.matchElementPrivilege(privileges, code, value)
    }
  }
}
</script>

<style lang="css">
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .action-generate {
    width: 150px;
    height: 150px;
    animation-delay: 0.8s;
    animation: twinkle 1.5s infinite;
  }

  @keyframes twinkle {
    0% {
      box-shadow: 0px 0px 5px #FFB300;
    }
    50% {
      box-shadow: 0px 0px 20px #FFB300;
    }
    100% {
      box-shadow: 0px 0px 5px #FFB300;
    }
  }
  .prohibit-generate{
    width: 150px;
    height: 150px;
    animation-delay: 0.8s;
    animation: prohibitTwinkle 1.5s infinite;
  }
  @keyframes prohibitTwinkle {
    0% {
      box-shadow: 0px 0px 5px #9e9e9e;
    }
    50% {
      box-shadow: 0px 0px 20px #9e9e9e;
    }
    100% {
      box-shadow: 0px 0px 5px #9e9e9e;
    }
  }
  .alert-icon {
    font-size: 40px;
  }
  .alert-text {
    font-size: 20px;
    font-weight: 500;
    margin-top: 5px;
  }
</style>
<style>
  .v-input--radio-group--column .v-input--radio-group__input {
    flex-direction: column;
  }
  .v-toolbar__content, .v-toolbar__extension {
    justify-content: space-between;
  }
</style>
